export const contactsData = {
    email: 'vibhashdwi1005@gmail.com',
    phone: '+91 9305529952',
    address: 'Lucknow, India',
    github: 'https://github.com/VibhashDwivedi',
    linkedIn: 'https://www.linkedin.com/in/vibhash-dwivedi/',
    leetcode: 'https://leetcode.com/vibhash_dwivedi/',
    gfg: 'https://auth.geeksforgeeks.org/user/vibhashdwi1005',
}